import { deviceLocale } from '@lib/datetime'

/*
 * Days in the Chat are the viewer's: a Message's instant falls on the day the
 * viewer's clock shows, like every other instant the app renders.
 */

const sameDay = (a: Date, b: Date): boolean =>
	a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

/**
 * What a day separator says: "Today", "Yesterday", or the date, with the year only when
 * it isn't this one. Ported from iOS `ChatDayTitle`.
 */
export const chatDayTitle = (date: Date, now: Date = new Date()): string => {
	if (sameDay(date, now)) return 'Today'
	if (sameDay(date, new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1))) return 'Yesterday'
	const options: Intl.DateTimeFormatOptions =
		date.getFullYear() === now.getFullYear()
			? { weekday: 'short', month: 'short', day: 'numeric' }
			: { year: 'numeric', month: 'short', day: 'numeric' }
	return date.toLocaleDateString(deviceLocale(), options)
}

/** The day itself, `YYYYMMDD` on the viewer's clock, so a separator keeps its identity as Messages arrive. */
export const chatDayKey = (date: Date): string =>
	`${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`
